import { GOAL_CARD_TEXT } from '@anqi/shared'
import type { GoalCardId, PlayerId } from '../protocol-types'
import { seatStyle } from './Board'

/**
 * 目标卡展示。
 *
 * 必须同时显示卡名和一句话说明：视图下发的只是 `'twinLines'` 这样的 id，
 * 只显示 id 或只显示卡名，玩家都不知道自己该往哪下。文案来自
 * `@anqi/shared` 的 GOAL_CARD_TEXT，与服务端同源。
 */
interface GoalCardProps {
  id: GoalCardId
  /** 围困卡才有：被指定的受害者 */
  siegeTarget?: PlayerId | null
  /** 谁的卡。自己的用「你的目标」，对手已亮的用他的名字 */
  ownerLabel: string
  /** 已亮牌的卡样式不同 —— 提醒玩家这张是公开的 */
  revealed?: boolean
}

export function GoalCard({ id, siegeTarget, ownerLabel, revealed = false }: GoalCardProps) {
  const text = GOAL_CARD_TEXT[id]
  return (
    <div
      className={[
        'rounded-lg border p-3',
        revealed ? 'border-amber-500/60 bg-amber-950/30' : 'border-slate-700 bg-slate-800',
      ].join(' ')}
    >
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-xs text-slate-400">{ownerLabel}</span>
        <span className="text-base font-bold">{text.name}</span>
      </div>
      <p className="mt-1 text-sm leading-snug text-slate-300">{text.description}</p>
      {/* 围困卡不指明目标就没法打 —— 这条信息只有持卡人看得到 */}
      {id === 'siege' && siegeTarget !== null && siegeTarget !== undefined && (
        <p className="mt-2 text-sm font-semibold text-amber-300">
          要围死的是 {seatStyle(siegeTarget).label}方
        </p>
      )}
    </div>
  )
}
